import { TProductRefIdV1 } from "@/types/plan";
import { TPlan } from "../types.checkout";

/**
 * Returns the legacy (v1) plan card that matches the user's v1 productRefId.
 *
 * @param v1PlanCards - V1 pricing cards (PRICING_CARD_V1)
 * @param v1ProductRefId - The v1 productRefId from the user's plan data
 */
export function getLegacyPlanList(
  v1PlanCards: TPlan[],
  v1ProductRefId: TProductRefIdV1,
): TPlan[] {
  return v1PlanCards.filter(
    (plan) => (plan.productRefId as string) === (v1ProductRefId as string),
  );
}
